import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getRouteV2 } from 'Config';
import useNavigate from 'Hooks/useNavigate';

import { getPostLoginRedirectPath } from 'Store/user/selectors';

import type { RouteConfigType } from '../../utils';

const authRedirect = (props: any) => {
  const {
    search,
    routeConfig,
    initialized,
    loggedIn,
    navigate,
    postLoginRedirectPath = null,
  } = props;
  const isAppAuthed = initialized && loggedIn;

  if (routeConfig.ignoreAuthCheck) {
    return;
  }

  if (routeConfig.authed) {
    // login/logout page
    if (isAppAuthed && !postLoginRedirectPath) {
      navigate(getRouteV2('recs'), { replace: true });
    }
  } else if (!isAppAuthed) {
    // fix user hitting back after logout
    navigate(`${getRouteV2('login', { pathConfig: { withPrefix: false } })}${search}`);
  }
};

const useAuthRedirect = (props: {
  search?: string | null;
  routeConfig: RouteConfigType | undefined;
  initialized: boolean;
  loggedIn: boolean;
}) => {
  const { search, routeConfig, initialized, loggedIn } = props;
  const navigate = useNavigate();
  const postLoginRedirectPath = useSelector(getPostLoginRedirectPath);
  useEffect(() => {
    authRedirect({ search, routeConfig, initialized, loggedIn, navigate, postLoginRedirectPath });
  }, [search, routeConfig, initialized, loggedIn, navigate, postLoginRedirectPath]);
};

export default useAuthRedirect;
